<template>
  <div id="myElement" style="position: absolute; width: 100%; height: 100%; top: 0; background: #f0f3f7">
    <div class="phoneBanner">
      <div class="phoneNav">
        <div class="timePhone" v-if="!isMo">
          {{ timeimit }}
        </div>

        <div class="submit" @click="submitExams">提交考卷</div>
        <div class="rightText" @click="phoneDialogVisible = true">答题卡</div>
      </div>
      <div class="bgk">
        <div class="swPos">
          <swiper id="PhoneSwiper" ref="myPhoneSwiper" class="swiper swiper-no-swiping">
            <!-- 单选题 -->
            <swiper-slide class="swiperslide swiper-slide" style="overflow: hidden" v-for="(item, index) in danxuanList" :key="item.id">
              <div class="content">
                <div class="titleTips">单选题</div>
                <div class="tim">{{ index + 1 }}: {{ item.content }}</div>
                <div class="box17" v-for="(img, idx) in item.imgs" :key="idx">
                  <img style="width: 100%" :src="img" alt="" />
                </div>

                <div class="xuanx">
                  <div class="scollBox box18">
                    <div
                      @click="onSelet(index, idx)"
                      v-for="(data, idx) in item.optionList"
                      :key="data.id"
                      :class="data.selected ? 'seletXuan xuan' : 'xuan'"
                    >
                      <div>
                        <!-- <img v-if="!data.selected"
                             class="box26"
                             src="../../assets/examImgs/nos@2x.png"
                             alt="" />
                        <img v-else 
                             class="box26"
                             src="../../assets/examImgs/se@2x.png"
                             alt="" /> -->
                      </div>
                      <div class="box25">
                        <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span
                        >&emsp;{{ data.opContent }}
                      </div>

                      <div class="box27" v-for="(img, idx) in data.imgs" :key="idx">
                        <img style="width: 100%" :src="img" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="dajx" @click="openJx(item)">查看答案</div>

              <div class="switchBox">
                <div class="btn" style="color: #4275f5" @click="pupTi(index)">上一题</div>
                <div @click="pdowTi(item, index)" class="btn box21">下一题</div>
              </div>
            </swiper-slide>

            <!-- 多选题 -->
            <swiper-slide class="swiperslide swiper-slide" style="overflow: hidden" v-for="(item, index) in duoxuanList" :key="item.id">
              <div class="content">
                <div class="titleTips">多选题</div>
                <div class="tim">{{ danxuanList.length + 1 + index }}: {{ item.content }}</div>
                <div class="box17" v-for="(img, idx) in item.imgs" :key="idx">
                  <img style="width: 100%" :src="img" alt="" />
                </div>

                <div class="xuanx">
                  <div class="scollBox box18">
                    <div
                      @click="onDuoSelet(index, idx)"
                      v-for="(data, idx) in item.optionList"
                      :key="data.id"
                      :class="data.selected ? 'seletXuan xuan' : 'xuan'"
                    >
                      <div>
                        <!-- <img v-if="!data.selected"
                             class="box26"
                             src="../../assets/examImgs/nos@2x.png"
                             alt="" />
                        <img v-else
                             class="box26"
                             src="../../assets/examImgs/se@2x.png"
                             alt="" /> -->
                      </div>
                      <div class="box25">
                        <span style="font-family: Bold">{{
                          idx == 0
                            ? 'A'
                            : idx == 1
                            ? 'B'
                            : idx == 2
                            ? 'C'
                            : idx == 3
                            ? 'D'
                            : idx == 4
                            ? 'E'
                            : idx == 5
                            ? 'F'
                            : idx == 6
                            ? 'G'
                            : idx == 7
                            ? 'H'
                            : 'I'
                        }}</span
                        >&emsp;{{ data.opContent }}
                      </div>
                      <div class="box17" v-for="(img, idx) in data.imgs" :key="idx">
                        <img style="width: 100%" :src="img" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dajx" @click="openJx(item)">查看答案</div>
              <div class="switchBox">
                <div class="btn" style="color: #4275f5" @click="pupTi(index)">上一题</div>
                <div @click="pdowTi(item, index)" class="btn box21">下一题</div>
              </div>
            </swiper-slide>

            <!-- 判断 -->
            <swiper-slide class="swiperslide swiper-slide" style="overflow: hidden" v-for="(item, index) in panduanList" :key="item.id">
              <div class="content">
                <div class="titleTips">判断题</div>
                <div class="tim">{{ danxuanList.length + duoxuanList.length + 1 + index }}: {{ item.content }}</div>
                <div class="box17" v-for="(img, idx) in item.imgs" :key="idx">
                  <img style="width: 100%" :src="img" alt="" />
                </div>

                <div class="xuanx">
                  <div class="scollBox box18">
                    <div
                      @click="onPanSelet(index, idx)"
                      v-for="(data, idx) in item.optionList"
                      :key="data.id"
                      :class="data.selected ? 'seletXuan xuan' : 'xuan'"
                    >
                      <div>
                        <!-- <img v-if="!data.selected"
                             class="box26"
                             src="../../assets/examImgs/nos@2x.png"
                             alt="" />
                        <img v-else
                             class="box26"
                             src="../../assets/examImgs/se@2x.png"
                             alt="" /> -->
                      </div>
                      <div class="box25">
                        <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span
                        >&emsp;{{ data.opContent }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dajx" @click="openJx(item)">查看答案</div>
              <div class="switchBox">
                <div class="btn" style="color: #4275f5" @click="pupTi(index)">上一题</div>
                <div @click="pdowTi(item, index)" class="btn box21">下一题</div>
              </div>
            </swiper-slide>

            <!-- 简答 -->
            <swiper-slide class="swiperslide swiper-slide" style="overflow: hidden" v-for="(item, index) in jiandaList" :key="item.id">
              <div>
                <div class="content">
                  <div class="titleTips">简答题</div>
                  <div class="tim">{{ danxuanList.length + duoxuanList.length + panduanList.length + 1 + index }}: {{ item.content }}</div>
                  <div class="box17" v-for="(img, idx) in item.imgs" :key="idx">
                    <img style="width: 100%" :src="img" alt="" />
                  </div>
                  <div class="xuanx">
                    <div class="scollBox box18" :key="num">
                      <el-input
                        class="box20"
                        @change="oninpus"
                        type="textarea"
                        :autosize="{ minRows: 20, maxRows: 30 }"
                        placeholder="请考生作答"
                        v-model="item.z"
                      >
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="switchBox">
                <div class="btn" style="color: #4275f5" @click="pupTi(index)">上一题</div>
                <div @click="dowTi(item, index)" class="btn box21">下一题</div>
              </div>
            </swiper-slide>

            <!-- 阅读理解 -->
            <swiper-slide class="swiperslide swiper-slide" style="overflow: hidden" v-for="(item, index) in shicaoList" :key="item.id">
              <div>
                <div class="content">
                  <div class="titleTips">阅读理解题</div>
                  <div class="tim">
                    {{ danxuanList.length + duoxuanList.length + jiandaList.length + panduanList.length + 1 + index }}: {{ item.content }}
                  </div>
                  <div class="box17" v-for="(img, idx) in item.imgs" :key="idx">
                    <img style="width: 100%" :src="img" alt="" />
                  </div>

                  <!-- 子单选题目 -->
                  <div class="content" v-if="item.subList_1.length !== 0">
                    <div class="titleTips">单选题</div>
                    <div class="timu box22" v-for="(msg, idx) in item.subList_1" :key="msg.pqId">
                      <div class="tim">&emsp;({{ idx + 1 }})&emsp;{{ msg.content }}</div>
                      <div class="box17" v-for="(img, idx) in msg.imgs" :key="idx">
                        <img style="width: 100%" :src="img" alt="" />
                      </div>
                    </div>
                  </div>
                  <!-- 子单选题目end -->

                  <!-- 子多选题目 -->
                  <div v-if="item.subList_2.length !== 0">
                    <div>多选题</div>
                    <div class="timu box22" v-for="(msg, idx) in item.subList_2" :key="msg.pqId">
                      <div class="box16">&emsp;({{ idx + 1 }})&emsp;{{ msg.content }}</div>
                      <div class="box17" v-for="(img, idx) in msg.imgs" :key="idx">
                        <img style="width: 100%" :src="img" alt="" />
                      </div>
                    </div>
                  </div>
                  <!-- 子多选题目end -->
                  <!-- 子判断题目 -->
                  <div v-if="item.subList_3.length !== 0">
                    <div>判断题</div>
                    <div class="timu box22" v-for="(msg, idx) in item.subList_3" :key="msg.pqId">
                      <div class="box16">&emsp;({{ idx + 1 }})&emsp;{{ msg.content }}</div>
                      <div class="box17" v-for="(img, idx) in msg.imgs" :key="idx">
                        <img style="width: 100%" :src="img" alt="" />
                      </div>
                    </div>
                  </div>
                  <!-- 子判断题目end -->

                  <!-- 子简答题 -->
                  <div v-if="item.subList_4.length !== 0">
                    <div>简答题</div>
                    <div class="timu box22" v-for="(msg, idx) in item.subList_4" :key="msg.pqId">
                      <div class="box16">&emsp;({{ idx + 1 }})&emsp;{{ msg.content }}</div>
                      <div class="box17" v-for="(img, idx) in msg.imgs" :key="idx">
                        <img style="width: 100%" :src="img" alt="" />
                      </div>
                    </div>
                  </div>
                  <!-- 子简答题end -->
                </div>
                <div class="xuanx box19">
                  <div class="scollBox box28">
                    <!-- 子单选题选项 -->
                    <div v-if="item.subList_1.length">
                      <div class="box29">单选题选项</div>
                      <div v-for="(dzt, cindex) in item.subList_1" :key="dzt.pqId">
                        <div class="box29">({{ cindex + 1 }})</div>
                        <div
                          @click="onzSelet(index, cindex, idx)"
                          v-for="(data, idx) in dzt.optionList"
                          :key="data.id"
                          :class="data.selected ? 'seletXuan xuan' : 'xuan'"
                        >
                          <div>
                            <!-- <img v-if="!data.selected" class="box26" src="../../assets/examImgs/nos@2x.png" alt="" /> -->
                            <!-- <img v-else class="box26" src="../../assets/examImgs/se@2x.png" alt="" /> -->
                          </div>
                          <div class="box25">
                            <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span
                            >&emsp;{{ data.opContent }}
                          </div>

                          <div class="box27" v-for="(img, idx) in data.imgs" :key="idx">
                            <img style="width: 100%" :src="img" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 子单选题选项end -->

                    <!-- 子多选题选项 -->
                    <div v-if="item.subList_2.length">
                      <div class="box29">多题选项</div>

                      <div v-for="(dzt, cindex) in item.subList_2" :key="dzt.pqId">
                        <div class="box29">({{ cindex + 1 }})</div>
                        <div
                          @click="onzDuoSelet(index, cindex, idx)"
                          v-for="(data, idx) in dzt.optionList"
                          :key="data.id"
                          :class="data.selected ? 'seletXuan xuan' : 'xuan'"
                        >
                          <!-- <div>
                            <img v-if="!data.selected" class="box26" src="../../assets/examImgs/nos@2x.png" alt="" />
                            <img v-else class="box26" src="../../assets/examImgs/se@2x.png" alt="" />
                          </div> -->
                          <div class="box25">
                            <span style="font-family: Bold">{{
                              idx == 0
                                ? 'A'
                                : idx == 1
                                ? 'B'
                                : idx == 2
                                ? 'C'
                                : idx == 3
                                ? 'D'
                                : idx == 4
                                ? 'E'
                                : idx == 5
                                ? 'F'
                                : idx == 6
                                ? 'G'
                                : idx == 7
                                ? 'H'
                                : 'I'
                            }}</span
                            >&emsp;{{ data.opContent }}
                          </div>

                          <div class="box27" v-for="(img, idx) in data.imgs" :key="idx">
                            <img style="width: 100%" :src="img" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 子多选题选项end -->

                    <!-- 子判断题选项 -->
                    <div v-if="item.subList_3.length">
                      <div class="box29">判断题选项</div>

                      <div v-for="(dzt, cindex) in item.subList_3" :key="dzt.pqId">
                        <div class="box29">({{ cindex + 1 }})</div>
                        <div
                          @click="onzPanSelet(index, cindex, idx)"
                          v-for="(data, idx) in dzt.optionList"
                          :key="data.id"
                          :class="data.selected ? 'seletXuan xuan' : 'xuan'"
                        >
                          <div>
                            <!-- <img v-if="!data.selected" class="box26" src="../../assets/examImgs/nos@2x.png" alt="" />
                            <img v-else class="box26" src="../../assets/examImgs/se@2x.png" alt="" /> -->
                          </div>
                          <div class="box25">
                            <span style="font-family: Bold">{{ idx == 0 ? 'A' : idx == 1 ? 'B' : idx == 2 ? 'C' : 'D' }}</span
                            >&emsp;{{ data.opContent }}
                          </div>
                          <div class="box27" v-for="(img, idx) in data.imgs" :key="idx">
                            <img style="width: 100%" :src="img" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 子判断题选项end -->

                    <!-- 子简答题选项 -->
                    <div v-if="item.subList_4.length">
                      <div class="box29">简答题选项</div>

                      <div v-for="(dzt, cindex) in item.subList_4" :key="dzt.pqId">
                        <div class="box29">({{ cindex + 1 }})</div>
                        <el-input
                          type="textarea"
                          @input="oninpus($event)"
                          :autosize="{ minRows: 20, maxRows: 30 }"
                          placeholder="请考生作答"
                          v-model="dzt.z"
                        >
                        </el-input>
                      </div>
                    </div>
                    <!-- 子简答题选项end -->
                  </div>
                  <div class="switchBox">
                    <div class="btn" style="color: #4275f5" @click="upTi(index)">上一题</div>
                    <div @click="dowTi(item, index)" class="btn box21">下一题</div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// Import Swiper Vue.js components
import { toJoinExam, handInNew, handIn, toJoinMockExam } from '@/api/exam';
import { Dialog } from 'vant';
// Import Swiper styles
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      phoneDialogVisible: false,
      examData: [], //题目数据
      swiperIndex: 0, //当前页面的题目索引
      num: 0, //key值重置
      danxuanList: [], //单选题的数组
      duoxuanList: [], //多选题
      panduanList: [], //判断题
      jiandaList: [], //简答题
      shicaoList: [], //阅读理解,阅读理解
      videoWidth: 170,
      videoHeight: 170,
      imgSrc: '',
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      //相机截图工具
      face_back_canvas: null,
      //截图内容
      face_back_context: null,
      //照片的base64码值
      face_back_base64Photo: '',
      showImg: false, //截图的图片
      carmerShow: false, //人脸识别组件
      examInfo: {}, //试卷数据
      timeimit: 0, //倒计时
      time: '', //倒计时
      interval: null, //定时器
      isSign: '01', //签到状态
      percentageNum: 0, //已做
      totleNum: 0, //总数
      handInTimer: null, //定时器
      findTimer: null,
      webSocket: null,
      surl: '',
      setIntervalWesocketPush: null, //定时器
      dialogVisible: false,
      isFullScreen: false,
      examType: '', //考试类型
      isMo: false, //ture模拟考试
      isMobile: null
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //查看答案
    openJx(item) {
      console.log(item);
      let xs = [];
      let xsId = [];
      let sedList = []; // 用户选择的题目
      let show = false; //判断用户是否选择正确
      item.optionList.forEach((v, k) => {
        if (v.selected) {
          sedList.push(v.id);
        }
        //项目号  A B C D E
        var opt = k + 1;
        var op = '';
        if (opt == 1) {
          op = 'A';
        } else if (opt == 2) {
          op = 'B';
        } else if (opt == 3) {
          op = 'C';
        } else if (opt == 4) {
          op = 'D';
        } else if (opt == 5) {
          op = 'E';
        } else if (opt == 6) {
          op = 'F';
        } else if (opt == 7) {
          op = 'G';
        } else if (opt == 8) {
          op = 'H';
        }
        //正确答案
        if (item.answer.indexOf(v.id) != -1) {
          xs.push(op);
          xsId.push(v.id);
        }
      });

      //判断题正确答案
      if (item.answer == '01') {
        xs.push('正确');
        xsId.push('正确');
      } else if (item.answer == '00') {
        xs.push('错误');
        xsId.push('错误');
      }
      console.log(xsId, sedList);
      if (sedList.length !== xsId.length) {
        show = false;
      } else {
        if (JSON.stringify(sedList.sort()) === JSON.stringify(xsId.sort())) {
          show = true;
        } else {
          show = false;
        }
      }
      Dialog.alert({
        title: !show ? '很遗憾您答错了！' : '恭喜您，您答对了！',
        message: '正确答案：' + xs
      }).then(() => {
        // on close
      });
    },
    goBack() {
      this.$router.back();
      this.handIn();
    },

    //输入框不能输入的bug
    oninpus(e) {
      this.$forceUpdate();
      console.log(e);
    },
    //处理考试进度百分比
    percentage() {
      this.totleNum =
        this.danxuanList.length + this.duoxuanList.length + +this.panduanList.length + this.jiandaList.length + this.shicaoList.length;
    },
    //五分钟提交一下试卷
    handIn() {
      let data = {
        uqId: this.examInfo.uqId,
        uqdId: this.examInfo.uqdId,
        type: '01'
      };
      this.danxuanList.forEach(v => {
        v.optionList.forEach(x => {
          if (x.selected) {
            data[v.pqId] = x.id;
          }
        });
      });
      this.duoxuanList.forEach(v => {
        let arr = [];
        v.optionList.forEach(x => {
          if (x.selected) {
            console.log(x);
            arr.push(x.id);
            console.log(arr);
            data[v.pqId] = arr.toString();
          }
        });
      });
      this.panduanList.forEach(v => {
        v.optionList.forEach(x => {
          if (x.selected) {
            data[v.pqId] = x.opContent == '正确' ? '01' : '00';
          }
        });
      });

      this.jiandaList.forEach(v => {
        if (v.z && v.z !== '') {
          data[v.pqId] = v.z;
        }
      });

      this.shicaoList.forEach(c => {
        if (c.subList_1.length !== 0) {
          c.subList_1.forEach(v => {
            v.optionList.forEach(x => {
              if (x.selected) {
                data[v.pqId] = x.id;
              }
            });
          });
        }

        if (c.subList_2.length !== 0) {
          c.subList_2.forEach(v => {
            let arr = [];
            v.optionList.forEach(x => {
              if (x.selected) {
                console.log(x);
                arr.push(x.id);
                console.log(arr);
                data[v.pqId] = arr.toString();
              }
            });
          });
        }

        if (c.subList_3.length !== 0) {
          c.subList_3.forEach(v => {
            v.optionList.forEach(x => {
              if (x.selected) {
                data[v.pqId] = x.opContent == '正确' ? '01' : '00';
              }
            });
          });
        }

        if (c.subList_4.length !== 0) {
          c.subList_4.forEach(v => {
            if (v.z && v.z !== '') {
              data[v.pqId] = v.z;
            }
          });
        }
      });
      handIn(data).then(res => {
        console.log(res);
      });
    },
    //提交试卷
    submitExams() {
      this.submitExam();
    },

    //提交试卷
    submitExam(id) {
      let data = {
        uqId: this.examInfo.uqId,
        uqdId: this.examInfo.uqdId,
        type: '01'
      };
      this.danxuanList.forEach(v => {
        v.optionList.forEach(x => {
          if (x.selected) {
            data[v.pqId] = x.id;
          }
        });
      });
      this.duoxuanList.forEach(v => {
        let arr = [];
        v.optionList.forEach(x => {
          if (x.selected) {
            console.log(x);
            arr.push(x.id);
            console.log(arr);
            data[v.pqId] = arr.toString();
          }
        });
      });
      this.panduanList.forEach(v => {
        v.optionList.forEach(x => {
          if (x.selected) {
            data[v.pqId] = x.opContent == '正确' ? '01' : '00';
          }
        });
      });

      this.jiandaList.forEach(v => {
        if (v.z && v.z !== '') {
          data[v.pqId] = v.z;
        }
      });

      this.shicaoList.forEach(c => {
        if (c.subList_1.length !== 0) {
          c.subList_1.forEach(v => {
            v.optionList.forEach(x => {
              if (x.selected) {
                data[v.pqId] = x.id;
              }
            });
          });
        }

        if (c.subList_2.length !== 0) {
          c.subList_2.forEach(v => {
            let arr = [];
            v.optionList.forEach(x => {
              if (x.selected) {
                console.log(x);
                arr.push(x.id);
                console.log(arr);
                data[v.pqId] = arr.toString();
              }
            });
          });
        }

        if (c.subList_3.length !== 0) {
          c.subList_3.forEach(v => {
            v.optionList.forEach(x => {
              if (x.selected) {
                data[v.pqId] = x.opContent == '正确' ? '01' : '00';
              }
            });
          });
        }

        if (c.subList_4.length !== 0) {
          c.subList_4.forEach(v => {
            if (v.z && v.z !== '') {
              data[v.pqId] = v.z;
            }
          });
        }
      });
      handInNew(data).then(res => {
        console.log(res);
        if (res.data.code == 200) {
          //提示成功
          Dialog.confirm({
            message: '提交试卷成功！'
          })
            .then(() => {
            })
          // this.$message({
          //   message: '提交试卷成功！',
          //   type: 'success'
          // });
          if (id == 2) {
            this.$router.push('/');
          } else {
            this.$router.push('/lsitFs');
          }
        } else {
          //提示失败
          this.$message(res.data.msg);
        }
      });
    },
    handleCountDown() {
      this.interval = setInterval(() => {
        this.time--;
        let minutes = Math.floor(this.time / 60);
        let seconds = Math.floor(this.time % 60);
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;
        this.timeimit = minutes + '分' + seconds + '秒';
        if (this.time === 0) {
          clearInterval(this.interval);
          //到时间自动交卷
          this.submitExam();
        }
      }, 1000);
    },
    //单选题选择选项
    onSelet(index, idx) {
      this.danxuanList[index].z = true;

      this.danxuanList[index].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        } else {
          v.selected = false;
        }
      });
      this.num = this.num + 1;
    },

    //多选题选择选项
    onDuoSelet(index, idx) {
      console.log(1);
      if (this.duoxuanList[index].optionList[idx].selected) {
        this.duoxuanList[index].optionList[idx].selected = false;
        if (this.duoxuanList[index].optionList.findIndex(target => target.selected === true) == -1) {
          this.duoxuanList[index].z = false;
        }
        this.percentageNum = this.percentageNum - 1;
        this.num = this.num + 1;
        return false;
      }
      this.duoxuanList[index].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        }
      });
      this.duoxuanList[index].optionList.forEach(v => {
        if (v.selected) {
          //多选题只要有一个选项是选中的
          this.duoxuanList[index].z = true;
        }
      });

      this.num = this.num + 1;
    },
    //判断题选择选项
    onPanSelet(index, idx) {
      console.log(this.panduanList[index]);
      this.panduanList[index].z = true;

      this.panduanList[index].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        } else {
          v.selected = false;
        }
      });
      this.num = this.num + 1;
    },
    //阅读理解子单选题选项
    onzSelet(index, cindex, idx) {
      console.log(index, cindex, idx);
      this.shicaoList[index].z = true;

      this.shicaoList[index].subList_1[cindex].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        } else {
          v.selected = false;
        }
      });
      this.num = this.num + 1;
    },
    //阅读理解子多选题选择选项
    onzDuoSelet(index, cindex, idx) {
      this.shicaoList[index].z = true;
      if (this.shicaoList[index].subList_2[cindex].optionList[idx].selected) {
        this.shicaoList[index].subList_2[cindex].optionList[idx].selected = false;
        this.shicaoList[index].z = false;
        this.percentageNum = this.percentageNum - 1;
        this.num = this.num + 1;
        return false;
      }
      this.shicaoList[index].z = true;

      this.shicaoList[index].subList_2[cindex].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        }
      });
      this.num = this.num + 1;
    },
    //判断题选择选项
    onzPanSelet(index, cindex, idx) {
      this.shicaoList[index].z = true;

      this.shicaoList[index].subList_3[cindex].optionList.forEach((v, vx) => {
        if (vx == idx) {
          v.selected = true;
        } else {
          v.selected = false;
        }
      });
      this.num = this.num + 1;
    },
    //答题卡点击事件
    toSn(idx) {
      if (this.isMo) {
        this.$refs.mySwiper.swiperInstance.slideTo(idx);
        this.swiperIndex = this.$refs.mySwiper.swiperInstance.activeIndex;
        this.phoneDialogVisible = false;

        return false;
      }
      this.$refs.mySwiper.swiperInstance.slideTo(idx);
      this.swiperIndex = this.$refs.mySwiper.swiperInstance.activeIndex;
      this.phoneDialogVisible = false;
    },
    //答题卡点击事件
    ptoSn(idx) {
      if (this.isMo) {
        this.$refs.myPhoneSwiper.swiperInstance.slideTo(idx);
        this.swiperIndex = this.$refs.myPhoneSwiper.swiperInstance.activeIndex;
        this.phoneDialogVisible = false;

        return false;
      }
      this.$refs.myPhoneSwiper.swiperInstance.slideTo(idx);
      this.swiperIndex = this.$refs.myPhoneSwiper.swiperInstance.activeIndex;
      this.phoneDialogVisible = false;
    },
    //移动端上一题
    pupTi(index) {
      this.$refs.myPhoneSwiper.swiperInstance.slidePrev();
      this.swiperIndex = this.$refs.myPhoneSwiper.swiperInstance.activeIndex;
      window.scrollTo(0, 0);
    },
    //移动端下一题
    pdowTi(item, index) {
      if (item.z) {
        this.percentageNum = this.percentageNum + 1;
      }
      this.$refs.myPhoneSwiper.swiperInstance.slideNext();
      this.swiperIndex = this.$refs.myPhoneSwiper.swiperInstance.activeIndex;
      window.scrollTo(0, 0);
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  },

  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.addEventListener(
      'storage',
      () => {
        this.$confirm('禁止打开多标签页！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showClose: false,
          distinguishCancelAndClose: true,
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
          .then(() => {
            window.open('about:blank', '_self');
            window.close();
          })
          .catch(() => {});
        window.open('about:blank', '_self');
        window.close();
      },
      false
    );
    localStorage.setItem('parrern', Math.random());

    let _this = this;
    _this.examType = _this.$route.query.type;
    //题目接口数据
    toJoinExam({ examPracticeQuizId: this.$route.query.id }).then(res => {
      _this.examData = res.data.data.data.list;
      _this.examInfo = res.data.data.data;
      _this.examData.forEach(item => {
        //处理数据
        if (item.qType == '0501') {
          _this.danxuanList = item.qList_0501;
          if (_this.danxuanList.length) {
            _this.danxuanList.forEach(v => {
              if (v.z) {
                _this.percentageNum = _this.percentageNum + 1;
              }
            });
          }
        } else if (item.qType == '0502') {
          _this.duoxuanList = item.qList_0502;

          if (_this.duoxuanList.length) {
            _this.duoxuanList.forEach(v => {
              if (v.z) {
                _this.percentageNum = _this.percentageNum + 1;
              }
            });
          }
        } else if (item.qType == '0503') {
          _this.panduanList = item.qList_0503;

          if (_this.panduanList.length) {
            _this.panduanList.forEach(v => {
              if (v.z) {
                _this.percentageNum = _this.percentageNum + 1;
              }
              v.optionList = [
                { opContent: '正确', selected: false, id: '正确' },
                { opContent: '错误', selected: false, id: '错误' }
              ];
            });
          }
        } else if (item.qType == '0504') {
          _this.jiandaList = item.qList_0504;

          if (_this.jiandaList.length) {
            _this.jiandaList.forEach(v => {
              if (v.z) {
                _this.percentageNum = _this.percentageNum + 1;
              }
              if (v.userAnswer !== null) {
                if (v.userAnswer.answer !== '' && v.userAnswer.answer !== null) {
                  v.z = v.userAnswer.answer;
                }
              }
            });
          }
        } else {
          _this.shicaoList = item.qList_0506;
          if (_this.shicaoList.length) {
            _this.shicaoList.forEach(v => {
              let arr = v.content.split('*');
              v.content = arr[0];
              arr.splice(0, 1);
              arr.splice(arr.length - 1, 1);
              v.imgs = arr;
              if (v.z) {
                _this.percentageNum = _this.percentageNum + 1;
              }
              //处理阅读理解题下的单选多选简答判断
              if (v.subList_1.length) {
                v.subList_1.forEach(cc => {
                  //分割图片和题目
                  let sArr = cc.content.split('*');
                  cc.content = sArr[0];
                  sArr.splice(0, 1);
                  sArr.splice(sArr.length - 1, 1);
                  cc.imgs = sArr;
                  cc.optionList.forEach(x => {
                    let ass = x.opContent.split('*');
                    x.opContent = ass[0];
                    ass.splice(0, 1);
                    ass.splice(ass.length - 1, 1);
                    x.imgs = ass;
                  });
                });
              }

              if (v.subList_2.length) {
                v.subList_2.forEach(cc => {
                  //分割图片和题目
                  let sArr = cc.content.split('*');
                  cc.content = sArr[0];
                  sArr.splice(0, 1);
                  sArr.splice(sArr.length - 1, 1);
                  cc.imgs = sArr;
                  cc.optionList.forEach(x => {
                    let ass = x.opContent.split('*');
                    x.opContent = ass[0];
                    ass.splice(0, 1);
                    ass.splice(ass.length - 1, 1);
                    x.imgs = ass;
                  });
                });
              }

              if (v.subList_3.length) {
                v.subList_3.forEach(cc => {
                  let arr = cc.content.split('*');
                  cc.content = arr[0];
                  arr.splice(0, 1);
                  arr.splice(arr.length - 1, 1);
                  cc.imgs = arr;
                  if (cc.userAnswer == null) {
                    cc.optionList = [
                      { opContent: '正确', selected: false },
                      { opContent: '错误', selected: false }
                    ];
                  } else if (cc.userAnswer.answer == '01') {
                    cc.optionList = [
                      { opContent: '正确', selected: true },
                      { opContent: '错误', selected: false }
                    ];
                  } else if (cc.userAnswer.answer == null) {
                    cc.optionList = [
                      { opContent: '正确', selected: false },
                      { opContent: '错误', selected: false }
                    ];
                  } else {
                    cc.optionList = [
                      { opContent: '正确', selected: false },
                      { opContent: '错误', selected: true }
                    ];
                  }
                });
              }

              if (v.subList_4.length) {
                v.subList_4.forEach(cc => {
                  let arr = cc.content.split('*');
                  cc.content = arr[0];
                  arr.splice(0, 1);
                  arr.splice(arr.length - 1, 1);
                  cc.imgs = arr;
                  if (cc.userAnswer !== null) {
                    if (cc.userAnswer.answer !== '' && cc.userAnswer.answer !== null) {
                      cc.z = cc.userAnswer.answer;
                    }
                  }
                });
              }
            });
          }
        }
      });
      _this.percentage();
      //开启五分钟记录试卷
      _this.handInTimer = setInterval(() => {
        _this.handIn();
      }, 5 * 60 * 1000);
    });

    let height1 = localStorage.getItem('height1');
    let height2 = localStorage.getItem('height2');
    if (document.documentElement.clientHeight.toString() == height1) {
      this.dialogVisible = true;
    }
    if (document.body.clientHeight.toString() == height2) {
      this.dialogVisible = true;
    }
  },
  destroyed() {},
  beforeDestroy() {
    //销毁定时器
    clearTimeout(this.setIntervalWesocketPush);
    clearInterval(this.handInTimer);
    clearInterval(this.findTimer);
    clearInterval(this.interval);
    this.handInTimer = null;
    this.findTimer = null;
    this.interval = null;
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.dajx {
  margin: 20px auto;
  width: 180px;
  height: 46px;
  background: #2a70f2;
  border-radius: 8px 8px 8px 8px;
  text-align: center;
  line-height: 46px;
  color: #fff;
}
.submit {
  width: 80px;
  height: 30px;
  background: #fe5f5e;
  box-shadow: 0px 3px 6px rgba(254, 95, 94, 0.31);
  opacity: 1;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #fff;
  font-size: 14px;
  font-family: Medium;
}
.examLeft {
  width: 240px;
  background: #ffffff;
  opacity: 1;
  border-radius: 12px;
  padding: 28px 20px;

  .danBox {
    display: flex;
    flex-wrap: wrap;
    font-family: Medium;
    font-size: 14px;
    .color5 {
      background: #5ad068;
      color: #fff;
      cursor: pointer;
    }
    .color6 {
      background: #f1f3f7;
      color: #8793a4;
      cursor: pointer;
    }
    .color7 {
      background: #4275f5;
      color: #fff;
      cursor: pointer;
    }
    div:nth-child(5n) {
      margin-right: 0 !important;
    }
  }
  .optionTips {
    width: 200px;
    height: 50px;
    border: 1px solid #8793a4;
    opacity: 1;
    border-radius: 12px;
    display: flex;
    align-items: center;
    color: #666666;
    font-family: Regular;
    font-size: 14px;
    .yuan {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      opacity: 1;
    }
  }
}
.box17 {
  margin: 10px auto auto auto;
}
.phoneBanner {
  font-family: Medium;
}
.pcBanner {
  display: none;
}
.phoneNav {
  width: 100%;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #4275f5;
  padding: 0 16px;
  .backIcon {
    width: 25px;
    height: 25px;
  }
  .timePhone {
    width: 94px;
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 17px;
    color: #fff;
    font-size: 17px;
    text-align: center;
    line-height: 32px;
  }
  .rightText {
    color: #fff;
    font-size: 15px;
  }
}
.bgk {
  width: 100%;
  padding: 20px 16px;
  .swPos {
    display: flex;
    justify-content: center;
    .switchBox {
      display: flex;
      margin-top: 26px;
      justify-content: space-between;
      .btn {
        width: 160px;
        height: 50px;
        border: 1px solid #4275f5;
        opacity: 1;
        border-radius: 25px;
        cursor: pointer;
        text-align: center;
        line-height: 50px;
        font-family: Medium;
        font-size: 16px;
      }
      .box21 {
        background: #4275f5;
        color: #fff;
      }
    }

    .content {
      width: 100%;
      padding: 24px 16px;
      background: #ffffff;
      border-radius: 8px;

      .titleTips {
        width: 62px;
        height: 26px;
        background: #4275f5;
        border-radius: 13px;
        text-align: center;
        line-height: 26px;
        font-size: 14px;
        color: #fff;
      }
      .tim {
        font-size: 18px;
        margin-top: 10px;
      }
      .xuanx {
        // margin-left: 35px;
        margin-top: 21px;
        .box26 {
          width: 25px;
          height: 25px;
        }
        .xuan {
          width: 100%;
          min-height: 47px;
          background: #f5f7fb;
          opacity: 1;
          border-radius: 12px;
          padding: 13px 16px;
          display: flex;
          font-size: 16px;
          font-family: Regular;
          cursor: pointer;
          margin-bottom: 20px;
        }
        .seletXuan {
          border-radius: 12px;
          background: rgba(66, 117, 245, 0.35) !important;
          color: #4275f5 !important;
        }
      }
    }
  }
}
.box14 {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  margin: 10px 10px 0 0;
}
.box13 {
  color: #333333;
  font-size: 15px;
}
.scollBox {
  overflow-x: hidden;
}
.scollBox::-webkit-scrollbar {
  width: 4px;
}
.scollBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
.scollBox::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.box15 {
  margin-top: 24px;
  font-family: Medium;
}
.danBox {
  display: flex;
  flex-wrap: wrap;
  font-family: Medium;
  font-size: 14px;
  .color5 {
    background: #5ad068;
    color: #fff;
    cursor: pointer;
  }
  .color6 {
    background: #f1f3f7;
    color: #8793a4;
    cursor: pointer;
  }
  .color7 {
    background: #4275f5;
    color: #fff;
    cursor: pointer;
  }
  div:nth-child(5n) {
    margin-right: 0 !important;
  }
}
.optionTips {
  width: 200px;
  height: 50px;
  margin-top: 10px;
  border: 1px solid #8793a4;
  opacity: 1;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #666666;
  font-family: Regular;
  font-size: 14px;
  .yuan {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    opacity: 1;
  }
  .box24 {
    background: #f1f3f7;
  }
}

.qd {
  width: 80px;
  height: 30px;
  background: #d3d3d3;
  opacity: 1;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  font-family: Medium;
}
.box35 {
  width: 16px;
  height: 16px;
}
</style>
